import React, { useState } from "react";
import { DeleteFilled, PlusOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Input, Modal, Table, message, Row, Col, Spin } from "antd";
import {
  useGetCarsQuery,
  useAddCarMutation,
  useDeleteCarMutation,
} from "../../../redux/Service/api";
import { ExclamationCircleFilled } from "@ant-design/icons";
import Heading from "../../../Components/Heading/Heading";
import ServerError from "../../../Components/utils/ServerError";

interface Car {
  CarID: number;
  CarNumber: string;
  Modal: string;
  Marka: string;
}

const { confirm } = Modal;

const Cars: React.FC = () => {
  const [openModal, setOpenModal] = useState(false);
  const [modalKey, setModalKey] = useState(0);
  const [carNumber, setCarNumber] = useState("");
  const [modal, setModal] = useState("");
  const [marka, setMarka] = useState("");

  const [addCar, { isLoading }] = useAddCarMutation();
  const [deleteCar, { isLoading: delIsLoading }] = useDeleteCarMutation();

  const {
    data: carsData,
    isError: isCarsError,
    isLoading: isCarsLoading,
  } = useGetCarsQuery(undefined);

  const cars: Car[] = carsData?.ResponseObject ?? [];

  const handleAddCar = async () => {
    if (!carNumber || !modal || !marka) {
      message.error("يرجى إدخال جميع البيانات");
      return;
    }

    const carPayload = {
      CarNumber: carNumber,
      Modal: modal,
      Marka: marka,
    };

    try {
      await addCar(carPayload);
      message.success("تمت إضافة السيارة بنجاح");
      setCarNumber("");
      setModal("");
      setMarka("");
      setModalKey((prev) => prev + 1);
      setOpenModal(false);
    } catch (error) {
      console.error("خطأ أثناء إضافة السيارة:", error);
      message.error("فشل في إضافة السيارة. يرجى المحاولة مرة أخرى.");
    }
  };

  const handleDeleteCar = (id: number) => {
    confirm({
      title: "هل أنت متأكد أنك تريد حذف هذه السيارة؟",
      icon: <ExclamationCircleFilled />,
      content: "بالضغط على موافق سيتم حذف السيارة بشكل دائم.",
      async onOk() {
        try {
          await deleteCar(id);
          message.success("تم حذف السيارة بنجاح");
        } catch (error) {
          console.error(error);
          message.error("فشل في حذف السيارة.");
        }
      },
    });
  };

  const columns = [
    {
      title: "رقم السيارة",
      dataIndex: "CarNumber",
      key: "CarNumber",
    },
    {
      title: "الموديل",
      dataIndex: "Modal",
      key: "Modal",
    },
    {
      title: "الماركة",
      dataIndex: "Marka",
      key: "Marka",
    },
    {
      title: "الإجراءات",
      key: "actions",
      render: (_: any, car: Car) => (
        <div className="flex gap-2">
          <Button
            type="text"
            icon={<DeleteFilled />}
            danger
            onClick={() => handleDeleteCar(car.CarID)}
          />
        </div>
      ),
    },
  ];

  return (
    <section className="p-4 section_padding mt-0 pt-0 relative">
      <Heading heading="السيارات" />

      {isCarsError && <ServerError />}

      <div className="text-center my-3">
        <Button
          className="w-[150px]"
          type="primary"
          onClick={() => setOpenModal(true)}
        >
          إضافة سيارة
        </Button>
      </div>

      <div className="mx-auto">
        <Table
          columns={columns}
          dataSource={cars}
          rowKey="CarID"
          loading={isCarsLoading || delIsLoading}
          pagination={{ pageSize: 5 }}
        />
      </div>

      <Modal
        title="إضافة سيارة"
        centered
        open={openModal}
        onCancel={() => setOpenModal(false)}
        footer={null}
        key={modalKey}
      >
        <div className="flex flex-col gap-4">
          <Row gutter={16}>
            <Col span={24}>
              <Input
                size="large"
                placeholder="أدخل رقم السيارة"
                value={carNumber}
                onChange={(e) => setCarNumber(e.target.value)}
              />
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Input
                size="large"
                placeholder="أدخل الموديل"
                value={modal}
                onChange={(e) => setModal(e.target.value)}
              />
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Input
                size="large"
                placeholder="أدخل الماركة"
                value={marka}
                onChange={(e) => setMarka(e.target.value)}
              />
            </Col>
          </Row>
          <Button type="primary" onClick={handleAddCar} loading={isLoading}>
            إضافة
          </Button>
        </div>
      </Modal>
    </section>
  );
};

export default Cars;
